<template>
	<div class='tw-flex-col tw--mx-3'>
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)">
			</c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="1"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-items-center tw-mb-6">
						<p class="tw-text-app-color-primary text-lg">
							Escoge tres verbos y complementalos:
						</p>
						<p-button
							type="primary"
							:disabled="chosenVerbs.length >= codeStep.maxVerbs"
							@click="chooseVerbs()"
						>Escoger Verbos
						</p-button>
					</div>
					<p-empty-message v-if="!chosenVerbs.length">
						ESCOGE 3 VERBOS Y<br>COMPLEMENTALOS
					</p-empty-message>
					<section v-else class="verbs-list">
						<div class="text-uppercase verbs-list-header tw-px-10 tw-py-1 tw-flex tw-justify-items-start tw-mb-4 tw-gap-x-20">
							<span>VERBO</span>
							<span>COMPLEMENTO</span>
						</div>
						<div class="list-verbs">
							<table>
								<tr v-for="(verb, index) in chosenVerbs" :key="index">
									<td class="verb">{{ verb.name }}</td>
									<td class="complement">
										<input
											placeholder="Complemento"
											class="list-verbs-input"
											v-model="complements[index]"
											@input="updateComplement($event, index)">
									</td>
									<td>
										<app-tooltip-button
											img="/static/img/close2.svg"
											text="Eliminar"
											@click-icon="deleteVerb(index)"
										/>
									</td>
								</tr>
							</table>
						</div>
					</section>
					<div>
						<p-horizontal-divider />
						<div class="tw-text-center">
							<p-button
								:disabled="!chosenVerbs.length || chosenVerbs.length < codeStep.maxVerbs || chosenVerbs.length > verbsComplements.length || disableBtn"
								type="secondary"
								@click="saveStepOne"
							>
								Siguiente
							</p-button>
						</div>
					</div>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'MISIÓN DEL PUESTO'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Escoge 3 verbos y responde a la pregunta ¿Para qué está este puesto?
							¿Cuál es el principal resultado, servicio o beneficio de este puesto?
						</p>
						<div class="content-box">
							<table>
								<tr>
									<th rowspan="11">Ejemplo:</th>
								</tr>
								<tr>
									<th class="titles">Verbo</th>
									<th class="titles">Complemento</th>
								</tr>
								<tr>
									<td class="borders"></td>
									<td class="borders"></td>
								</tr>
								<tr>
									<td class="verbs">Organizar</td>
									<td class="complements">a todo el equipo de contabilidad.</td>
								</tr>
								<tr>
									<th class="titles">Verbo</th>
									<th class="titles">Complemento</th>
								</tr>
								<tr>
									<td class="borders"></td>
									<td class="borders"></td>
								</tr>
								<tr>
									<td class="verbs">Dirigir</td>
									<td class="complements">toda las áreas de la empresa.</td>
								</tr>
								<tr>
									<th class="titles">Verbo</th>
									<th class="titles">Complemento</th>
								</tr>
								<tr>
									<td class="borders"></td>
									<td class="borders"></td>
								</tr>
								<tr>
									<td class="verbs">Diseñar</td>
									<td class="complements">plande estrategía para tu equipo.</td>
								</tr>
							</table>
						</div>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
								@click="selectTemplate"
							>
							Plantillas de Puestos Descritos
							</p-button>
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
						<button class="content-pet" @click="openModal">
							<img src="/static/img/pet-ki2.png" alt="">
						</button>
						<div v-if="modalVisible" :class="{ 'modal': true, 'visible': modalVisible }" @click.self="closeModal">
							<div class="modal-content">
								<p-card class="content-message">
									<span class="close" @click="closeModal">&times;</span>
									<p>Hey! Usa tus sugerencias y agrega<br>tus puestos descritos con un solo click</p>
									<p-button
										type="primary"
										size="small"
										@click="redirectToTemplate">
										Plantillas de Puestos Descritos
									</p-button>
								</p-card>
								<img src="/static/img/pet-ki.png" alt="">
							</div>
						</div>
					</div>
				</model-description>
			</div>
		</div>
		<verbs-selection-dialog
			v-if="verbsSelection && selectedJob"
			ref="verbSelectionDialog"
			:selected-job="selectedJob"
			@onSave="listVerbs"
			>
		</verbs-selection-dialog>
		<verbs-loading-template-dialog
			ref="verbLoadingTemplateDialog"
			@reload="selectedTemplate"
			></verbs-loading-template-dialog>
	</div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import verbsSelectionDialog from '@/modules/job-profile/components/first-step/verbs-selection-dialog';
import verbsLoadingTemplateDialog from '@/modules/job-profile/components/first-step/verbs-loading-template-dialog';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { path, pathOr } from 'ramda';

const { getLocalData } = helper;

async function loadData() {
	try {
		if (this.codeStep && this.selectedJob) {
			// ✅ USAR CACHE - Llamar al servicio centralizado con cache
			const response = await this.$store.dispatch('jobProfile/loadJobDescription', {
				codeStep: this.codeStep.code,
				jobId: this.selectedJob.id,
			});

			if (Object.keys(response).length !== 0) {
				this.chosenVerbs = response.description.map(item => item.verb);
				this.complements = response.description.map(item => item.complement);
				this.verbsComplements = response.description;
			}
		}
	} catch (error) {
		this.showGenericError();
	}
}

function chooseVerbs() {
	this.$refs.verbSelectionDialog.open();
}

function selectTemplate() {
	this.$refs.verbLoadingTemplateDialog.open();
}
function redirectToTemplate() {
	this.$refs.verbLoadingTemplateDialog.open();
	this.modalVisible = false;
}

function listVerbs(verbs) {
	this.complements = [];
	this.verbsComplements = [];
	if (verbs.length > this.codeStep.maxVerbs) {
		this.showNotification('RECUERDA: Solo debes escoger 3 verbos', 'warning');
		this.chosenVerbs = verbs;
	} else if (verbs.length < this.codeStep.maxVerbs) {
		this.showNotification('RECUERDA: Deben ser al menos 3 verbos', 'warning');
		this.chosenVerbs = verbs;
	} else {
		this.chosenVerbs = verbs;
	}
}

function deleteVerb(index) {
	this.chosenVerbs.splice(index, 1);
}

function updateComplement(event, index) {
	this.complements[index] = event.target.value;
	if (!this.verbsComplements[index]) {
		this.verbsComplements[index] = {};
	}
	this.verbsComplements[index].verb = this.chosenVerbs[index];
	this.verbsComplements[index].complement = this.complements[index];
	this.disableBtn = this.verbsComplements.some(f => f.complement === '');
	if (this.disableBtn) {
		this.showNotification('Complemente todos los verbos seleccionados', 'warning');
	}
}

async function saveStepOne() {
	const result = this.hierarchyAssignation.map((assig) => {
		const newJobPosition = assig.jobPositions
			.find(job => job.id === this.selectedJob.id);
		if (newJobPosition) {
			return {
				job: {
					id: assig.id,
					name: assig.job,
				},
				newJob: newJobPosition,
			};
		}
		return null;
	});
	const filteredResult = result.filter(item => item !== null);
	this.verbsComplements = this.verbsComplements.map((f) => {
		const newF = { ...f };
		newF.verb = {
			id: f.verb.id,
			code: f.verb.code,
			name: f.verb.name,
		};
		return newF;
	});
	let inmediateBoss = {};
	if (this.selectedJob.additionalInformation) {
		inmediateBoss.id = this.selectedJob.additionalInformation.immediateBoss.id;
		inmediateBoss.name = this.selectedJob.additionalInformation.immediateBoss.name;
	} else {
		// this.showNotification();
		inmediateBoss = {
			id: null,
			name: null,
		};
	}
	const body = {
		description: this.verbsComplements,
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
		additionalInformation: {
			levelHierarchy: filteredResult[0].job,
			fatherName: {
				id: filteredResult[0].newJob.fatherId ? filteredResult[0].newJob.fatherId
					: inmediateBoss.id,
				name: filteredResult[0].newJob.fatherName ?
					filteredResult[0].newJob.fatherName
					: inmediateBoss.name,
			},
		},
	};
	try {
		if (inmediateBoss.id === null || inmediateBoss.name === null) {
			throw Error('INCOMPLETE_JOBS');
		}
		await this.$httpPraktiko.post('job-description', body);

		// ✅ INVALIDAR CACHE - Limpiar cache del job que se acaba de guardar
		this.$store.dispatch('jobProfile/clearJobDescriptionCache', this.selectedJob.id);

		this.showNotification('Misión del Puesto Guardado Exitosamente');
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		if (error.message === 'INCOMPLETE_JOBS') {
			this.showNotification('Campos incompletos en el puesto, para continuar complete los campos faltantes', 'warning');
		} else {
			this.showGenericError();
		}
	}
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

function selectedTemplate(value) {
	if (value === true) {
		this.loadData();
	}
}

function data() {
	return {
		chosenVerbs: [],
		verbsComplements: [],
		complements: [],
		disableBtn: false,
		codeStep: {},
		modalVisible: false,
	};
}

export default {
	name: 'job-mission',
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		modelDescription,
		verbsSelectionDialog,
		verbsLoadingTemplateDialog,
	},
	data,
	// ✅ OPTIMIZADO: model-stepper ya carga la configuración
	// beforeCreate() {
	// 	this.$store.dispatch('jobProfile/loadJobProfileConfig');
	// },
	mounted() {
	},
	methods: {
		loadData,
		chooseVerbs,
		listVerbs,
		deleteVerb,
		selectTemplate,
		redirectToTemplate,
		updateComplement,
		saveStepOne,
		loadCodeStep,
		selectedTemplate,
		openModal() {
			this.modalVisible = true;
		},
		closeModal() {
			this.modalVisible = false;
		},
	},
	computed: {
		...mapState('jobEvaluation', {
			verbsSelection: path(['supplies', 'guidelineModel', 'verbsSelection']),
			hierarchyAssignation: path(['supplies', 'guidelineModel', 'hierarchyAssignation']),
		}),
		...mapState('jobProfile', {
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
		verbsSelection: {
			handler(newVal) {
				this.verbsSelection = newVal;
			},
		},
	},
	props: [],
};
</script>

<style lang="scss" scoped>
.content-box {
	border: 1px solid color(border-gray);
	background-color: color(gray-light);
	border-radius: 5px;
	height: auto;
	width: 100%;
	padding: 10px;
	table {
		width: 100%;
		// border-collapse: collapse;
		text-align: center;
		font-size: 12px;
	}
	.borders {
		border-top: 1px solid color(green-dark);
		border-left: 1px solid color(green-dark);
		border-right: 1px solid color(green-dark);
		padding: 2px 0;
	}
	.titles {
		color: color(green-dark);
	}
	.verbs {
		color: color(orange-light);
	}
	.complements {
		color: color(gray-slider);
	}
}
.content-pet {
	position: fixed;
	bottom: 40px;
	right: 50px;
	height: auto;
	animation: bounceEffect 1s ease-in-out;
	transition: transform 0.3s ease;
	img {
		width: 100px;
		transform-origin: center center;
	}
}

.content-pet:hover {
	transform: scale(1.1);
}

@keyframes bounceEffect {
	0%, 20%, 50%, 80%, 100% {
		transform: translateY(0);
	}
	40% {
		transform: translateY(-20px);
	}
	60% {
		transform: translateY(-10px);
	}
}

.verbs-list {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
}
.list-verbs {
	display: flex;
	bottom: 0;
	left: 0;
	padding: 0;
	position: relative !important;
	right: 0;
	table {
		width: 100%;
		.verb {
			color: color(orange-light);
			font-size: size(large);
			padding-left: 10px;
			width: 20%;
		}
		.complement {
			width: 70%;
		}
	}

	&-input {
		background: map-get($colors, white);
		border: 1px solid map-get($colors, gray-slider);
		border-radius: 4px;
        display: block;
        outline: none;
		color: color(gray-tabs) !important;
		margin-top: 4px;
		padding: 10px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
.modal {
	display: none;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 999;
	background-color: rgba(0,0,0,0.2);
	&-content {
		position: absolute;
		bottom: 50px;
		right: 50px;
		width: 150px;
		height: 150px;
		border-radius: 50%;
		background-color: color(white);
		padding: 20px;
		text-align: center;
	}
	img {
		width: 200px;
	}
}
.visible {
	display: block;
}
.content-message {
	position: absolute;
	width: 300px;
	top: -40px;
	left: -220px;
	p {
		color: color(orange-dark);
	}
}
.close {
	position: absolute;
	top: 3px;
	right: 12px;
	cursor: pointer;
	color: color(orange-dark);
	font-family: font(bold);
	font-size: size(xlarge);
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/first-page/job-mission.vue